import jsPDF from "jspdf";
import { loadLogo, drawLogo } from "./loadLogo";

export async function generateCertificate(userName, completionDate) {
  const [mark, fullLogo] = await Promise.all([loadLogo("/logo-mark.png"), loadLogo("/logo.png")]);
  const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Background
  doc.setFillColor(253, 252, 248); // #FDFCF8
  doc.rect(0, 0, pageWidth, pageHeight, "F");

  // Outer border
  doc.setDrawColor(30, 58, 138); // #1E3A8A
  doc.setLineWidth(3);
  doc.rect(10, 10, pageWidth - 20, pageHeight - 20, "S");

  // Inner border
  doc.setLineWidth(0.5);
  doc.rect(15, 15, pageWidth - 30, pageHeight - 30, "S");

  // Corner accents (decorative squares)
  const cornerSize = 8;
  const corners = [
    [18, 18],
    [pageWidth - 18 - cornerSize, 18],
    [18, pageHeight - 18 - cornerSize],
    [pageWidth - 18 - cornerSize, pageHeight - 18 - cornerSize],
  ];
  doc.setFillColor(30, 58, 138);
  corners.forEach(([x, y]) => doc.rect(x, y, cornerSize, cornerSize, "F"));

  // Header accent line
  const centerX = pageWidth / 2;
  // Logo mark centered above the title
  drawLogo(doc, mark, centerX, 18, 21, "center");
  doc.setDrawColor(163, 230, 213); // #A3E6D5
  doc.setLineWidth(1.5);
  doc.line(centerX - 60, 42, centerX + 60, 42);

  // Title: "CERTIFICATE"
  doc.setFont("helvetica", "normal");
  doc.setFontSize(14);
  doc.setTextColor(30, 58, 138);
  doc.text("C E R T I F I C A T E   O F", centerX, 52, { align: "center" });

  // "COMPLETION"
  doc.setFont("helvetica", "bold");
  doc.setFontSize(36);
  doc.setTextColor(30, 58, 138);
  doc.text("COMPLETION", centerX, 66, { align: "center" });

  // Divider
  doc.setDrawColor(30, 58, 138);
  doc.setLineWidth(0.8);
  doc.line(centerX - 50, 72, centerX + 50, 72);

  // "This certifies that"
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(80, 80, 80);
  doc.text("This certifies that", centerX, 84, { align: "center" });

  // User name
  doc.setFont("helvetica", "bold");
  doc.setFontSize(28);
  doc.setTextColor(30, 25, 24); // #1A1918
  doc.text(userName || "Valued Customer", centerX, 98, { align: "center" });

  // Name underline
  doc.setDrawColor(163, 230, 213);
  doc.setLineWidth(1);
  const nameWidth = doc.getTextWidth(userName || "Valued Customer");
  doc.line(centerX - nameWidth / 2 - 10, 101, centerX + nameWidth / 2 + 10, 101);

  // Description
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(80, 80, 80);
  doc.text("has successfully completed all 9 steps of the", centerX, 113, { align: "center" });

  // Program name
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.setTextColor(30, 58, 138);
  doc.text("Texas LLC Formation Guide", centerX, 125, { align: "center" });

  // Steps description
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  const stepsText = "Choosing a Unique Name \u2022 Appointing a Registered Agent \u2022 Filing Certificate of Formation \u2022 Operating Agreement";
  doc.text(stepsText, centerX, 135, { align: "center" });
  const stepsText2 = "Obtaining an EIN \u2022 Business Banking \u2022 Franchise Tax \u2022 Licenses & Permits \u2022 Annual Compliance";
  doc.text(stepsText2, centerX, 141, { align: "center" });

  // Date
  const formattedDate = completionDate || new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(80, 80, 80);
  doc.text(`Completed on ${formattedDate}`, centerX, 155, { align: "center" });

  // Bottom accent
  doc.setDrawColor(30, 58, 138);
  doc.setLineWidth(0.5);
  doc.line(centerX - 40, 162, centerX + 40, 162);

  // Brand — full logo bottom-left, with company name beneath
  drawLogo(doc, fullLogo, centerX - 25, 164, 15, "center");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(30, 58, 138);
  doc.text("LEWIS EXPERT ENTERPRISE", centerX - 25, 183, { align: "center" });

  // Signature line (right side)
  doc.setDrawColor(80, 80, 80);
  doc.setLineWidth(0.3);
  doc.line(centerX + 30, 175, centerX + 80, 175);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text("Administrator", centerX + 55, 180, { align: "center" });

  // Certificate ID (small)
  const certId = `CERT-${Date.now().toString(36).toUpperCase()}`;
  doc.setFontSize(7);
  doc.setTextColor(180, 180, 180);
  doc.text(certId, pageWidth - 20, pageHeight - 12, { align: "right" });

  doc.save("Texas_LLC_Completion_Certificate.pdf");
}
